import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import landingPages from '../content/landingPages.json';
import { supabase } from '../supabaseClient';
import {
    useCatalog, Hero, Highlights, Categories, Bikes, Series, Prices, Sizes, Steps,
    AccessoryCategories, Accessories, Visit, Faq, Related, Workshop
} from '../components/landing/LandingSections';

const SECTIONS = {
    hero: Hero, highlights: Highlights, categories: Categories, bikes: Bikes, series: Series, prices: Prices,
    sizes: Sizes, steps: Steps, accessoryCategories: AccessoryCategories, accessories: Accessories,
    visit: Visit, faq: Faq, related: Related, workshop: Workshop
};

// SEO landing pages; copy and section order live in src/content/landingPages.json.
const LandingPage = ({ path }) => {
    const page = landingPages[path];
    const catalog = useCatalog();
    const [products, setProducts] = useState([]);
    const needsProducts = page.sections.some((s) => s.type === 'accessories' || s.type === 'accessoryCategories');

    useEffect(() => {
        if (!needsProducts) return;
        supabase.from('products').select('id, name, category, image_url').order('created_at', { ascending: false })
            .then(({ data }) => setProducts(data || []));
    }, [needsProducts]);

    return (
        <main className="bg-white">
            <Helmet>
                <title>{page.seo.title}</title>
            </Helmet>
            {page.sections.map((section, index) => {
                const Section = SECTIONS[section.type];
                if (!Section) return null;
                return (
                    <React.Fragment key={`${section.type}-${index}`}>
                        <Section section={section} catalog={catalog} products={products} />
                        {index === 0 && (
                            <nav aria-label="Ruta de navegación" className="max-w-[1600px] mx-auto px-6 md:px-12 pt-8 text-xs font-bold uppercase tracking-widest text-gray-400">
                                <Link to="/" className="hover:text-black">Inicio</Link> / <span className="text-black">{page.breadcrumb}</span>
                            </nav>
                        )}
                    </React.Fragment>
                );
            })}
        </main>
    );
};

export default LandingPage;
